import * as React from "react";
import { TApiQuestionEntity } from "../../types/Survey";
import QuestionIcons from "./QuestionIcons";
import QuestionHelpTextInline from "./QuestionHelpTextInline";

interface IQuestionHeadingProps {
  question: TApiQuestionEntity;
  setModalOpen: (value: React.SetStateAction<boolean>) => void;
}

const QuestionHeading: React.FC<IQuestionHeadingProps> = ({
  question,
  setModalOpen,
}): JSX.Element => {
  const hasInlineHelpText = !!question.helpText && question.helpTextInline;

  return (
    <>
      <div style={{ display: "flex", alignItems: "baseline", gap: "8px" }}>
        <h1
          style={{
            textAlign: "left",
            flex: 1,
            marginBottom: hasInlineHelpText ? "8px" : undefined,
          }}
        >
          {question.body}
        </h1>
        <QuestionIcons question={question} setModalOpen={setModalOpen} />
      </div>
      <QuestionHelpTextInline question={question} />
    </>
  );
};

export default QuestionHeading;
